import { render, staticRenderFns } from "./MultiContent.vue?vue&type=template&id=176f7b37"
import script from "./MultiContent.vue?vue&type=script&lang=js"
export * from "./MultiContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports